import type { StandardServicePageContent } from "~/content/servicePage";

export const BuildingInspectionContent: StandardServicePageContent = {
  heroTitle: "Przegląd budowlany",
  quickFactsTitle: "Najważniejsze informacje w skrócie",
  quickFacts: [
    {
      label: "Jak często",
      value: "Co rok lub co 5 lat",
      description:
        "Zakres zależy od typu obiektu i obowiązków z art. 62 Prawa budowlanego. Pięcioletnia kontrola ma szerszy zakres, a roczne przeglądy dotyczą wybranych elementów narażonych na szybkie zużycie i warunki atmosferyczne.",
    },
    {
      label: "Ile kosztuje",
      value: "Od kilkuset zł za prosty obiekt",
      description:
        "Cena zależy od wielkości budynku, rodzaju kontroli, liczby części wspólnych i zakresu dokumentacji. Dom, mała wspólnota i większy budynek usługowy mają zupełnie inną wycenę.",
    },
    {
      label: "Co obejmuje",
      value: "Stan techniczny budynku i protokół z zaleceniami",
      description:
        "Ocenia się dach, elewację, balkony, odwodnienie, części wspólne i inne elementy narażone na uszkodzenia. W szerszych kontrolach dochodzą również instalacje oraz ocena przydatności obiektu do użytkowania.",
    },
    {
      label: "Kiedy działać wcześniej",
      value: "Po przeciekach, wichurach lub zauważonych uszkodzeniach",
      description:
        "Dodatkowa kontrola ma sens po intensywnych opadach, uszkodzeniu dachu, pęknięciach, odspojeniach elewacji albo przed większym remontem. To pomaga szybciej ocenić ryzyko i priorytety napraw.",
    },
  ],
  faqTitle: "Najczęstsze pytania o przegląd budowlany",
  sections: [
    {
      title: "Na czym polega przegląd budowlany i co daje właścicielowi",
      paragraphs: [
        `Przegląd budowlany polega na ocenie stanu technicznego budynku i wychwyceniu uszkodzeń, zużycia oraz zaniedbań, które mogą przełożyć się na bezpieczeństwo użytkowania albo wyższe koszty remontowe w przyszłości.`,
        `Taka kontrola ma wartość praktyczną: porządkuje obowiązki właściciela lub zarządcy, pomaga planować budżet napraw i pokazuje, czy obiekt nadaje się do dalszego bezpiecznego użytkowania. Dobrze wykonany przegląd nie kończy się na ogólnym opisie, ale wskazuje konkretne miejsca wymagające interwencji.`,
        `Po wizycie właściciel powinien otrzymać protokół z oceną stanu budynku i zaleceniami. To ważne zarówno dla domu jednorodzinnego, jak i dla wspólnoty, spółdzielni czy budynku usługowego.`,
      ],
    },
    {
      title: "Roczny i pięcioletni przegląd budynku",
      paragraphs: [
        `Roczny przegląd budynku skupia się na elementach najbardziej narażonych na działanie warunków atmosferycznych i codziennej eksploatacji, takich jak dach, elewacja, balkony, balustrady, odwodnienie czy obróbki blacharskie. To właśnie wtedy najczęściej wychodzą przecieki, korozja i spękania.`,
        `Pięcioletni przegląd ma szerszy zakres i obejmuje ocenę stanu technicznego oraz przydatności obiektu do użytkowania, a także estetyki budynku i jego otoczenia. W tym trybie sprawdza się również instalację elektryczną i piorunochronną, co odróżnia go od węższych kontroli prowadzonych częściej.`,
        `W praktyce oba typy przeglądów uzupełniają się. Roczna kontrola pozwala szybko wychwycić bieżące uszkodzenia, a pięcioletnia daje szerszy obraz stanu technicznego i pomaga planować większe działania remontowe.`,
      ],
    },
    {
      title: "Kto wykonuje przegląd budowlany i co zawiera protokół",
      paragraphs: [
        `Kontrolę stanu technicznego budynku wykonują osoby posiadające odpowiednie uprawnienia budowlane albo kwalifikacje właściwe dla danego zakresu. W części instalacyjnej i branżowej często potrzebny jest udział specjalistów z odpowiednimi uprawnieniami branżowymi.`,
        `Dla właściciela najważniejsze jest to, aby dokument podpisała osoba, która może legalnie ocenić dany zakres kontroli. Ma to znaczenie szczególnie przy większych obiektach oraz w sytuacjach, gdy przegląd obejmuje kilka różnych branż technicznych.`,
        `Dobry protokół powinien rozdzielać usterki pilne od tych, które można zaplanować w dalszym harmonogramie utrzymania obiektu. Dzięki temu przegląd staje się narzędziem do zarządzania budynkiem, a nie tylko formalnością.`,
      ],
    },
    {
      title: "Cena przeglądu budowlanego",
      paragraphs: [
        `Cena przeglądu budowlanego zaczyna się zwykle od kilkuset złotych dla prostych obiektów, ale rośnie wraz z wielkością budynku, zakresem kontroli i liczbą elementów wymagających oględzin. Dom jednorodzinny, budynek wielorodzinny i obiekt usługowy są wyceniane zupełnie inaczej.`,
        `Na koszt wpływa również to, czy chodzi o kontrolę roczną, pięcioletnią, dokumentację zdjęciową i szczegółowe zalecenia po przeglądzie. W większych miastach ceny bywają wyższe ze względu na dojazd, dostępność terminów i bardziej rozbudowaną strukturę obiektów.`,
        `Przy porównywaniu ofert warto sprawdzić, czy cena obejmuje pełny protokół i czy zakres kontroli odpowiada rzeczywistym potrzebom budynku. Sama najniższa stawka bez jasnego opisu usług zwykle niewiele mówi o jakości przeglądu.`,
      ],
    },
  ],
  scopeTitle: "Zakres usług przeglądu budowlanego",
  scopeItems: [
    "Ocena dachu i pokrycia",
    "Kontrola elewacji",
    "Sprawdzenie balkonów i balustrad",
    "Ocena odwodnienia",
    "Kontrola części wspólnych",
    "Weryfikacja uszkodzeń i zawilgoceń",
    "Zalecenia naprawcze",
    "Protokół z dokumentacją",
  ],
  seo: {
    title: "Przegląd budowlany: roczny, 5-letni, cena, protokół",
    description:
      "Przegląd budowlany roczny i pięcioletni dla domu, wspólnoty i budynku usługowego. Sprawdź zakres kontroli, cenę, kto wykonuje przegląd i co zawiera protokół.",
  },
};
